import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// Extractors   

const getPatterns = (state: AppState) => state.patterns.patterns;

export const getPatternsSelector = createSelector(getPatterns, (patterns) => patterns);

//Custom Extractors
const postCustExtPending = (state: AppState) => state.metadetaCustExtReducer.pending;
const postCustExtExtractor = (state: AppState) => state.metadetaCustExtReducer.extractor;
const postCustExtError = (state: AppState) => state.metadetaCustExtReducer.error;

export const postCustExtPendingSelector = createSelector(postCustExtPending, (pending) => pending);
export const postCustExtSelector = createSelector(postCustExtExtractor, (extractor) => extractor);
export const postcustExtErrorSelector = createSelector(postCustExtError, (error) => error);


//DBExtractors
const postDBExtPending = (state: AppState) => state.metaDataPostDBExtReducer.pending;
const postDBExtExtractor = (state: AppState) => state.metaDataPostDBExtReducer.extractor;
const postDBExtError = (state: AppState) => state.metaDataPostDBExtReducer.error;

export const postDBExtPendingSelector = createSelector(postDBExtPending, (pending) => pending);
export const postDBExtSelector = createSelector(postDBExtExtractor, (extractor) => extractor);
export const postDBExtErrorSelector = createSelector(postDBExtError, (error) => error);


// extractor list 

const getExtractorListPending = (state: AppState) => state.extractors.pending;
const getExtractorList = (state: AppState) => state.extractors.extractors;
const getExtractorListError = (state: AppState) => state.extractors.error;

export const getExtractorListSelector = createSelector(getExtractorList, (extractors) => extractors);
export const getExtractorListPendingSelector = createSelector(getExtractorListPending,(pending) => pending);
export const getExtractorListErrorSelector = createSelector(getExtractorListError, (error) => error);

// extractor details
const getExtractorDetailPending = (state: AppState) => state.extractorDetail.pending;
const getExtractorDetail = (state: AppState) => state.extractorDetail.extractorDetail;
const getExtractorDetailError = (state: AppState) => state.extractorDetail.error;

export const getExtractorDetailSelector = createSelector(getExtractorDetail, (extractors) => extractors);
export const getExtractorDetailPendingSelector = createSelector(getExtractorDetailPending,(pending) => pending);
export const getExtractorDetailErrorSelector = createSelector(getExtractorDetailError, (error) => error);

// delete extractor

const deleteExtractorPending = (state: AppState) => state.deleteExtractor.pending;
const deleteExtractor = (state: AppState) => state.deleteExtractor.deleteStatus;
const deleteExtractorError = (state: AppState) => state.deleteExtractor.error;

export const deleteExtractorSelector = createSelector(deleteExtractor, (extractor) => extractor);
export const deleteExtractorPendingSelector = createSelector(deleteExtractorPending,(pending) => pending);
export const deleteExtractorErrorSelector = createSelector(deleteExtractorError, (error) => error);

// PUT extractor

const putDataPending = (state: AppState) => state.putExtractor.pending;
const putExtractor = (state: AppState) => state.putExtractor.extractor;
const putDataError = (state: AppState) => state.putExtractor.error;

export const putExtractorPendingSelector = createSelector(putDataPending, (pending) => pending);
export const putExtractorSelector = createSelector(putExtractor, (extractor) => extractor);
export const putExtractorErrorSelector = createSelector(putDataError, (error) => error);

// extractor details
const getExtractorStatusPending = (state: AppState) => state.extractorStatus.pending;
const getExtractorStatus = (state: AppState) => state.extractorStatus.extractorStatus;
const getExtractorStatusError = (state: AppState) => state.extractorStatus.error;

export const getExtractorStatusSelector = createSelector(getExtractorStatus, (extractorStatus) => extractorStatus);
export const getExtractorStatusPendingSelector = createSelector(getExtractorStatusPending,(pending) => pending);
export const getExtractorStatusErrorSelector = createSelector(getExtractorStatusError, (error) => error);

//Post Schema Extractors
const postSchemaExtPending = (state: AppState) => state.postSchemaExt.pending;
const postSchemaExt = (state: AppState) => state.postSchemaExt.extractor;
const postSchemaExtError = (state: AppState) => state.postSchemaExt.error;

export const postSchemaExtPendingSelector = createSelector(postSchemaExtPending, (pending) => pending);
export const postSchemaExtSelector = createSelector(postSchemaExt, (extractor) => extractor);
export const postSchemaExtErrorSelector = createSelector(postSchemaExtError, (error) => error);

//Post retry Schema update
const postRetrySchemaUpdatePending = (state: AppState) => state.retrySchemaUpdate.pending;
const postRetrySchemaUpdateExt = (state: AppState) => state.retrySchemaUpdate.extractor;
const postRetrySchemaUpdateError = (state: AppState) => state.retrySchemaUpdate.error;

export const postRetrySchemaUpdatePendingSelector = createSelector(postRetrySchemaUpdatePending, (pending) => pending);
export const postRetrySchemaUpdateExtSelector = createSelector(postRetrySchemaUpdateExt, (extractor) => extractor);
export const postRetrySchemaUpdateErrorSelector = createSelector(postRetrySchemaUpdateError, (error) => error);